<template>
  <div>
    <router-link :to="{name: 'teacher'}" class="back-link">&larr; Back to all forms</router-link>
    <div class="form-name">{{formName}}</div>
    <SubmittedForm :message="formResponseMsg" v-if="formSubmitted" />
    <div
      v-else-if="formComplete"
      class="submitted-text"
      >
        Your form was submitted
    </div>
    <form @submit="submitForm" v-else>
      <div :style="progress" class="progress-bar"></div>
      <div
        v-if="(currentQuestionObject || {}).QuestionType === 'likert-type'"
        class="likert-reminder"
      >Your answer to this question will be kept anonymous.</div>
      <div
        v-if="(currentQuestion === 1)"
        class="likert-reminder"
      >Clicking next will automatically save your response. You can revisit the form and edit your answers until you click submit or until the response window closes.</div>
      <div
        v-for="question in questionsAndResponses"
        :key="question.QuestionID"
        class="all-questions-container"
      >
        <div v-if="question.OrderID === currentQuestion" class="single-question-container">
          <ShortAnswerActive
            v-if="(question || {}).QuestionType === `short answer`"
            v-on:dispatch-input="handleInput"
            :question="question"
          />
          <LikertTypeActive
            v-if="(question || {}).QuestionType === `likert-type`"
            v-on:dispatch-input="handleInput"
            :question="question"
          />
          <BinaryActive
            v-if="(question || {}).QuestionType === `binary`"
            v-on:dispatch-input="handleInput"
            :question="question"
          />
        </div>
      </div>
      <div class="buttons-and-validation">
        <div class="validation">{{validationMsg}}</div>
        <div class="button-container">
          <button
            v-if="currentQuestion > 1"
            @click="() => nextQuestion('previous')"
            class="button prev"
            type="button"
          >Prev</button>
          <button
            v-if="currentQuestion < questionsAndResponses.length"
            @click="() => nextQuestion('next')"
            class="button next"
            type="button"
          >Next</button>
          <input
            v-if="currentQuestion === questionsAndResponses.length"
            class="button submit-button"
            type="submit"
            value="SUBMIT"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BinaryActive from "./BinaryActive.vue";
import LikertTypeActive from "./LikertTypeActive.vue";
import ShortAnswerActive from "./ShortAnswerActive.vue";
import SubmittedForm from "./SubmittedForm.vue";
import store from "@/store/index.js";

import axios from "axios";
const apiBase = API_APP_PATH + "/v1";

export default {
  data() {
    return {
      currentQuestion: 1,
      validationMsg: null,
      formResponseMsg: {},
      questionsAndResponses: [],
      formName: "",
      sessionTimedOut: false,
      responses: [],
      formSubmitted: false,
      newTeacher: false,
      newAtSchool: false
    };
  },
  components: {
    LikertTypeActive,
    ShortAnswerActive,
    BinaryActive,
    SubmittedForm
  },
  created() {
    const componentContext = this;
    componentContext
      .getQuestionsAndResponses()
      .then(res => {
        componentContext.formName = res[0].FormName;
        componentContext.questionsAndResponses = res;
      })
      .catch(e => {
        throw new Error(e);
      });
  },
  methods: {
    keepAlive() {
      const componentContext = this;
      axios
        .get(`${apiBase}/auth/keepalive`)
        .then(() => {})
        .catch(() => {
          componentContext.sessionTimedOut = true;
          window.location.href =
            "/Auth/SSO/DOE_SSO.php?source=/growthexplorer/#/";
        });
    },
    saveCurrentResponse() {
      const responseToSave = this.tempResponse(
        this.questionsAndResponses.filter(
          _question => _question.OrderID === this.currentQuestion
        )[0]
      );
      if (!responseToSave.Comment) return;
      axios({
        method: "post",
        url: `${apiBase}/data/school/responses/new/temp`,
        data: { responseToSave }
      })
        .then(resp => {
          resp;
        })
        .catch(e => {
          e;
        });
    },
    getQuestionsAndResponses: async function() {
      const responsesByFormAndUser = await axios.get(
        `${apiBase}/data/school/goalSetting/form/${this.$route.params.formid}/teacher/${store.state.employeeId}`
      );
      return responsesByFormAndUser.data;
    },
    nextQuestion(direction) {
      this.keepAlive();
      switch (direction) {
        case "next":
          this.saveCurrentResponse();
          this.incrementQuestion();
          break;
        case "previous":
          this.decrementQuestion();
          this.validationMsg = null;
          break;
      }
    },
    incrementQuestion(overrideValidation) {
      if (this.missingInput && !overrideValidation) {
        this.validationMsg = `You need to answer this question. `;
        return;
      }
      if (!this.questionsRemain) return;
      this.currentQuestion++;
      this.validationMsg = null;
      // used to implement branching logic
      // if (!this.shouldDisplayQuestion) return this.incrementQuestion(true);
    },
    decrementQuestion() {
      if (this.currentQuestion > 1) this.currentQuestion--;
      // used to implement branching logic
      // if (!this.shouldDisplayQuestion) return this.decrementQuestion();
    },
    handleInput(event) {
      for (let i = 0; i < this.questionsAndResponses.length; i++) {
        if (this.questionsAndResponses[i].QuestionID === event.questionId) {
          this.questionsAndResponses[i].Comment = event.Comment;
          this.$set(
            this.questionsAndResponses,
            i,
            this.questionsAndResponses[i]
          );
          if (this.currentQuestionObject.Period === "BOY") {
            this.setTeacherType(
              this.questionsAndResponses[i].Question,
              event.Comment
            );
          }
          break;
        }
      }
    },
    setTeacherType(question, response) {
      switch (question) {
        case "Is this your first year teaching?":
          this.newTeacher = response === "Yes" ? true : false;
          break;
        case "Is this your first year teaching at your current school?":
          this.newAtSchool = response === "Yes" ? true : false;
          break;
        default:
          return;
      }
    },
    response(question) {
      return {
        UserID: question.EmployeeId,
        ParentID: question.FormID,
        ReferenceID: question.QuestionID,
        Comment: question.Comment,
        ReferenceType: "form",
      };
    },
    tempResponse(question) {
      return {
        UserID: question.EmployeeId,
        ParentID: question.FormID,
        ReferenceID: question.QuestionID,
        Comment: question.Comment,
        ReferenceType: "temp-form",
      };
    },
    newFormResponse() {
      const componentContext = this;
      return this.questionsAndResponses.reduce((responses, question) => {
        return question.Comment
          ? responses.concat(componentContext.response(question))
          : responses;
      }, []);
    },
    sendEmail() {
      const { emailBody } = this;
      return axios({
        method: "post",
        url: `${apiBase}/data/school/email`,
        data: {
          subject: `Professional Goal Setting Form Submitted`,
          body: emailBody
        }
      });
    },
    postResponses() {
      const componentContext = this;
      return axios({
        method: "post",
        url: `${apiBase}/data/school/responses/new`,
        data: { responses: componentContext.newFormResponse(), dbn: componentContext.questionsAndResponses[0].SchoolDBN }
      });
    },
    submitForm(event) {
      event.preventDefault();
      const componentContext = this;
      this.postResponses()
        .then(() => {
          componentContext.formSubmitted = true;
          componentContext.formResponseMsg = {
            success: true,
            msg: `Success! Your answers were submitted to your school administrators. To review the form you just submitted or any previous forms, please click 'Back to all forms' above.`
          };
        })
        .then(() => {
          this.sendEmail()
            //TODO: Make this a toast instead of adding it to the conf msg
            .then(() => {
              componentContext.formResponseMsg.msg += ` An email confirmation was sent to ${store.state.userName}@schools.nyc.gov.`;
            })
            .catch(e => {
              componentContext.formResponseMsg.msg += ` Unable to send a confirmation email to ${store.state.userName}@schools.nyc.gov. ${e}`;
            });
        })
        .catch(() => {
          componentContext.formResponseMsg = {
            success: false,
            msg: `Oh no! There was a problem submitting your form. `
          };
          componentContext.formSubmitted = true;
        });
    },
    // setInitialTeacherType(responses) {
    //   if (this.currentQuestionObject.Period !== "BOY") return;

    //   const newTeacherQuestion = "";
    //   const newToSchoolQuestion = "";
    //   for (let i = 0; i < responses.length; i++) {
    //     if (
    //       responses[i].Question === "Is this your first year teaching?" &&
    //       responses[i].Comment === "Yes"
    //     )
    //       this.newTeacher = true;
    //     if (
    //       responses[i].Question ===
    //         "Is this your first year teaching at your current school?" &&
    //       responses[i].Comment === "Yes"
    //     )
    //       this.newAtSchool = true;
    //   }
    // }
  },
  computed: {
    // This function is used to enable branching logic on the Beggining of Year Forms
    // I'm leaving it commented out in case we decide to employ branching logic again
    // shouldDisplayQuestion() {
    //   const {
    //     Comment,
    //     Question,
    //     Required,
    //     Period
    //   } = this.currentQuestionObject;
    //   // We only employ branching logic on the BOY form
    //   if (Period !== "BOY") return true;
    //   //handle new teachers
    //   if (this.newTeacher) {
    //     //question is for returning teachers only
    //     if (
    //       returningTeacherQuestions.indexOf(Question) !== -1 ||
    //       returningToSchoolQuestions.indexOf(Question) !== -1
    //     )
    //       return false;
    //     //question is for anyone
    //     return true;
    //   }
    //   // handle returning teachers
    //   if (!this.newTeacher) {
    //     //question is for new teachers
    //     if (newTeacherQuestions.indexOf(Question) !== -1) return false;
    //     //question is only for returning teachers at the school
    //     if (
    //       returningToSchoolQuestions.indexOf(Question) !== -1 &&
    //       this.newAtSchool
    //     )
    //       return false;
    //     //question is for any returning teacher
    //     return true;
    //   }
    // },
    formComplete() {
      // when a form gets submitted all of the rows in GEX_Comments (for the current user) with ReferenceType = 'temp-form' are deleted
      // and the latest responses are added to GEX_Comments with ReferenceType = 'form'
      return this.questionsAndResponses.some(question => question.ReferenceType === 'form')
    },
    questionsRemain() {
      return this.currentQuestion < this.questionsAndResponses.length;
    },
    emailBody() {
      return `<div>Hi ${store.state.firstName},</div><br><br><div>Your form ${this.questionsAndResponses[0].FormName} was submitted successfully.</div><br /><br /><div>- <a href="https://tools.nycenet.edu/Auth/SSO/DOE_SSO.php?source=/growthexplorer/#/">Growth Explorer</a></div>`;
    },
    missingInput() {
      const { Comment, Required } = this.currentQuestionObject;
      return Required === 1 && !Comment ? true : false;
    },
    progress() {
      return `background: linear-gradient(to right,#2c557d 0%,#2c557d ${Number(
        (this.currentQuestion / this.questionsAndResponses.length) * 100
      ).toFixed(0)}%,#ffffff ${Number(
        (this.currentQuestion / this.questionsAndResponses.length) * 100
      ).toFixed(0)}%,#ffffff 100%)`;
    },
    currentQuestionObject() {
      return this.questionsAndResponses.filter(
        question => question.OrderID === this.currentQuestion
      )[0];
    }
  }
};
</script>

<style scoped>
.likert-reminder {
  font-family: Arial, Helvetica, sans-serif;
  padding: 0 0.5em 1em 0.5em;
  color: #ae6401;
}
.single-question-container {
  height: 15em;
}
.buttons-and-validation {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 9em;
  justify-content: space-around;
}
.validation {
  font-family: Arial;
  font-size: 1em;
  font-weight: bold;
  color: #ae6401;
}
.button-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 1em;
}
.button {
  background-color: #2c557d;
  color: white;
  border: none;
  padding: 0.75em;
  width: 8em;
  font-size: 1em;
}

.progress-bar {
  width: 80%;
  height: 1em;
  margin: 1em 0 2em 1em;
  border: 1px solid #2c557d;
  border-radius: 1em;
}
.back-link {
  font-family: Arial, Helvetica, sans-serif;
}
.form-name {
  height: 2.25em;
  font-family: Arial;
  font-size: 1.5em;
  color: #000000;
  margin: 1em 0em 1em 0.5em;
}
.submitted-text {
  height: 2.25em;
  font-family: Arial;
  font-size: 1em;
  color: #000000;
  margin: 1em 0em 1em 0.5em;
}
</style>